export class SearchInput {
    // options.selector;
    // options.targets;
    // options.autofocus;
    constructor(options) {
        this.options = options;
        this.input = document.querySelector(this.options.selector);
        this.targets = document.querySelectorAll(this.options.targets);
        this.input.addEventListener('input', () => this.onInput());
        if (this.options.autofocus == true) {
            this.input.focus();
        }
    }
    onInput() {
        this.value = this.getInputValue();
        if (this.value.length == 0) return this.resetTargets();

        this.targets.forEach(target => {
            if (target.dataset.searchTerm.toLowerCase().indexOf(this.value) > -1) {
                // match
                target.classList.add('match');
            } else {
                // no match
                target.classList.remove('match');
            }
        })
    }
    getInputValue() {
        console.log('hello');
        return this.input.value.toLowerCase();
    }
    resetTargets() {
        this.targets.forEach(t => {
            t.classList.remove('match');
        })
    }
}